const FETCH_ESSENTIAL_EXTRAS_REQUEST = 'FETCH_ESSENTIAL_EXTRAS_REQUEST'
const FETCH_ESSENTIAL_EXTRAS_SUCCESS = 'FETCH_ESSENTIAL_EXTRAS_SUCCESS'
const FETCH_ESSENTIAL_EXTRAS_FAILURE = 'FETCH_ESSENTIAL_EXTRAS_FAILURE'
const FETCH_EXTRAS_DATA_REQUEST = 'FETCH_EXTRAS_DATA_REQUEST'
const FETCH_EXTRAS_DATA_SUCCESS = 'FETCH_EXTRAS_DATA_SUCCESS'
const FETCH_EXTRAS_DATA_FAILURE = 'FETCH_EXTRAS_DATA_FAILURE'

export {
  FETCH_ESSENTIAL_EXTRAS_REQUEST,
  FETCH_ESSENTIAL_EXTRAS_SUCCESS,
  FETCH_ESSENTIAL_EXTRAS_FAILURE,
  FETCH_EXTRAS_DATA_REQUEST,
  FETCH_EXTRAS_DATA_SUCCESS,
  FETCH_EXTRAS_DATA_FAILURE
}
